<div class="flex flex-col h-[-webkit-fill-available]">
  <div class="flex justify-between items-center m-4 border-b border-customBlueHard">
    <p class="text-lg font-semibold color-blue">
      {{ this.data.Titule }}
    </p>

    <div class="flex justify-between items-center gap-4">
      <button
        (click)="downloadFileFromBlob()"
        class="flex! justify-center! items-center!"
        color="primary"
        mat-icon-button
      >
        <mat-icon>download</mat-icon>
      </button>
      <button
        (click)="closeModal()"
        class="flex! justify-center! items-center!"
        color="primary"
        mat-icon-button
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="flex h-full w-full min-w-75 md:min-w-125 lg:min-w-175">
    @if (pdfSrc) {
      <pdf-viewer
        [src]="pdfSrc"
        [render-text]="true"
        [original-size]="false"
        [fit-to-page]="true"
        style="display: block; width: 100%; height: 80vh"
      ></pdf-viewer>
    }

    @if (imagePreview) {
      <div class="p-2 mx-auto flex justify-center items-center h-full w-full">
        <img
          class="max-h-100 sm:max-h-125 md:max-h-150 lg:max-h-162.5 w-full object-contain"
          [src]="imagePreview"
          [attr.alt]="'modals.fileViewer.imagePreviewAlt' | translate"
          width="100%"
        />
      </div>
    }

    @if (videoSrc) {
      <div class="p-2 mx-auto flex justify-center items-center h-full w-full">
        <div class="h-full object-contain">
          <video controls autoplay class="h-full rounded-3xl outline-none">
            <source [src]="videoSrc" type="video/mp4" />
            {{ 'modals.fileViewer.videoNotSupported' | translate }}
          </video>
        </div>
      </div>
    }

    @if (isDoc) {
      <div class="p-8 flex justify-center items-center">
        <mat-icon class="text-customBlueHard text-8xl h-25! w-25! m-auto">description</mat-icon>
      </div>
    }
  </div>
</div>
